import moment from 'moment';
import Graph from 'graph';

export default class Dashboard {
  setupGraph() {
    let requests = [
      {
        endpoint: "/metrics/incidents.json",
        incident_type: $('.js-incident-type').data('value'),
        private_actors: $('.js-actor').data('value'),
        group: $('.js-incident-type').data('value'),
        start_date: $('.js-start-date').data('value'),
        end_date: $('.js-end-date').data('value'),
        duration: $('.js-date-range-selector.active').data("range") === "last-3-months" ? "week" : "month" 
      }
    ]

    var options = {
      graph_type: 'area',
      graph_colors: ['#85786B'],
      background_color: '#FAF6F2',
      graph_area_color: 'rgba(161, 112, 68, 0.2)',
    };
    let graph = new Graph();
    graph.build(requests, options)
  }

  static formatDate(date) {
    let MONTH_NAMES = [
      "January", "February", "March", "April", "May", "June", "July", 
      "August", "September", "October", "November", "December"
    ];
    var date = new Date(date)
    var month = MONTH_NAMES[date.getMonth()]
    var day = date.getDate()
    var year = date.getFullYear()
    return month + " " + day + ", " + year
  };
}

$(document).ready(function() {
  var today = new Date();
  let dashboard = new Dashboard;

  if ($('#js-dashboard').length) {
    $('.js-start-date').data('value', moment().subtract(1, 'year').toDate())
    $('.js-end-date').data('value', Dashboard.formatDate(new Date()))
    $('.js-incident-type').data('value', "civilian_abductions")
    $('.js-actor').data('value', "all_armed_groups")
    const dashboard = new Dashboard();
    dashboard.setupGraph();

    $('.js-date-range-selector').click(function(event) {
      let selector = $(event.target)
      var startDate = Dashboard.formatDate(new Date()); 
      var endDate = Dashboard.formatDate(new Date()); 
      selector.closest('.js-date-range-selectors').find('.js-date-range-selector').removeClass('active')
      selector.addClass('active')
      if(selector.data('range') == "year-to-date") {
        startDate = moment().subtract(1, 'year').toDate();
      } else if(selector.data('range') == "last-3-months") {
        startDate = moment().subtract(3, 'months').toDate();
      } else if(selector.data('range') == "all-time") {
        startDate = moment("2008-01-01").toDate();
      }
      $('.js-start-date').data('value', startDate)
      $('.js-end-date').data('value', endDate)
      dashboard.setupGraph()
    })

    $('.js-dashboard-incident-type-selection').click(function(event) {
      let selection = $(event.target);
      $('.js-dashboard-incident-type-selection').removeClass('active');
      selection.addClass('active');
      selection.closest('.js-dashboard-incident-type-container').find('.js-text').text($(selection).text());
      $('.js-incident-type').data('value', selection.data('key'));
      dashboard.setupGraph()
    })

    $('.js-dashboard-actor-selection').click(function(event) {
      let selection = $(event.target);
      $('.js-dashboard-actor-selection').removeClass('active');
      selection.addClass('active');
      selection.closest('.js-dashboard-actor-container').find('.js-text').text($(selection).text());
      $('.js-actor').data('value', selection.data('key'));
      dashboard.setupGraph()
    })
  }
})
